import { useEffect } from "react";
import {
  redirectToMobileInstall,
  shouldAffiliateMobileInstallRedirect,
} from "../utils/affiliateInstallRedirect";
import {
  captureSignupReferrer,
  getInstallAttributionParams,
  getSignupReferrerDomain,
} from "../services/AttributionService";

export default function useAffiliateMobileInstallRedirect(): void {
  useEffect(() => {
    if (shouldAffiliateMobileInstallRedirect()) {
      captureSignupReferrer();
      redirectToMobileInstall(
        window.location.search,
        getSignupReferrerDomain(),
        getInstallAttributionParams(),
      );
    }
  }, []);
}
